/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_V1_Press_ReutersInputs */

const en_onboarding_v1_press_reuters = /** @type {(inputs: Onboarding_V1_Press_ReutersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reuters`)
};

const de_onboarding_v1_press_reuters = /** @type {(inputs: Onboarding_V1_Press_ReutersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reuters`)
};

const pt_br2_onboarding_v1_press_reuters = /** @type {(inputs: Onboarding_V1_Press_ReutersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reuters`)
};

const tr_onboarding_v1_press_reuters = /** @type {(inputs: Onboarding_V1_Press_ReutersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reuters`)
};

const zh_cn2_onboarding_v1_press_reuters = /** @type {(inputs: Onboarding_V1_Press_ReutersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reuters`)
};

const zh_hk2_onboarding_v1_press_reuters = /** @type {(inputs: Onboarding_V1_Press_ReutersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reuters`)
};

const ko_kr2_onboarding_v1_press_reuters = /** @type {(inputs: Onboarding_V1_Press_ReutersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reuters`)
};

const ru_ru2_onboarding_v1_press_reuters = /** @type {(inputs: Onboarding_V1_Press_ReutersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reuters`)
};

const es_419_onboarding_v1_press_reuters = /** @type {(inputs: Onboarding_V1_Press_ReutersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reuters`)
};

/**
* | output |
* | --- |
* | "Reuters" |
*
* @param {Onboarding_V1_Press_ReutersInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const onboarding_v1_press_reuters = /** @type {((inputs?: Onboarding_V1_Press_ReutersInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_V1_Press_ReutersInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_v1_press_reuters(inputs)
	if (locale === "de") return de_onboarding_v1_press_reuters(inputs)
	if (locale === "pt-BR") return pt_br2_onboarding_v1_press_reuters(inputs)
	if (locale === "tr") return tr_onboarding_v1_press_reuters(inputs)
	if (locale === "zh-CN") return zh_cn2_onboarding_v1_press_reuters(inputs)
	if (locale === "zh-HK") return zh_hk2_onboarding_v1_press_reuters(inputs)
	if (locale === "ko-KR") return ko_kr2_onboarding_v1_press_reuters(inputs)
	if (locale === "ru-RU") return ru_ru2_onboarding_v1_press_reuters(inputs)
	return es_419_onboarding_v1_press_reuters(inputs)
});